import React, { useState } from "react";
import "./form.css";
import { toast } from "react-toastify";
const AddForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    schoolName: "",
    website:"",
    designation:"",
    email: "",
    phone: "",
    city: "",
    state: "",
    pincode: "",
  });

  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSendOtp = async () => {
    if (!formData.email) return alert("Enter email first");

    setLoading(true);
    const respons = await fetch("https://support.ace-school-backend.serverscripts.in/api/v1/send-otp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: formData.email }),
    });
        setOtpSent(true);
        setLoading(false);
    };

  const handleVerifyOtp = async () => {
    if (!otp) return alert("Enter OTP");

    setLoading(true);
    const res = await fetch("https://support.ace-school-backend.serverscripts.in/api/v1/verify-otp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: formData.email, otp }),
    });

    const data = await res.json();
    if (data.success) setEmailVerified(true);
    else alert("Invalid OTP");

    setLoading(false);
  };

  const handleSubmit = async () => {
  try {
    if (!emailVerified) {
      alert("Verify email first");
      return;
    }

    const response = await fetch(
      "https://support.ace-school-backend.serverscripts.in/api/v1/form-add",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      }
    );

    const data = await response.json();

    if (!data.success) {
      toast.error(data.message || "Failed to submit form");
      return;
    }

    toast.success(data.message || "Form submitted successfully");
setFormData({
  name: "",
  schoolName: "",
  website: "",
  designation: "",
  email: "",
  phone: "",
  city: "",
  state: "",
  pincode: "",
});

setOtp("");
setOtpSent(false);
setEmailVerified(false);

  } catch (error) {
    toast.error("Something went wrong. Please try again.");
  }
};

const handleChange = async (e) => {
  const { name, value } = e.target;

  if (name === "phone" && (!/^\d*$/.test(value) || value.length > 10)) return;
  if (name === "pincode" && (!/^\d*$/.test(value) || value.length > 6)) return;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  if (name === "pincode" && value.length < 6) {
    setFormData((prev) => ({
      ...prev,
      city: "",
      state: "",
    }));
    return;
  }

  if (name === "pincode" && value.length === 6) {
    try {
      const res = await fetch(`https://api.postalpincode.in/pincode/${value}`);
      const data = await res.json();

      if (data[0].Status === "Success") {
        const postOffice = data[0].PostOffice[0];

        setFormData((prev) => ({
          ...prev,
          city: postOffice.District,
          state: postOffice.State,
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          city: "",
          state: "",
        }));
        toast.error("Invalid Pincode");
      }
    } catch (error) {
      toast.error("Failed to fetch location");
    }
  }
};

  return (
    <div className="min-h-screen w-full flex flex-col md:flex-row bg-gradient-to-br from-blue-100 via-white to-purple-100">

      
      <div className="hidden md:flex w-1/2 items-center justify-center p-10">
        <div>
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            Welcome
          </h1>
          <p className="text-gray-600 text-lg">
            Fill the form to register your school and our team will connect with you.
          </p>
        </div>
      </div>

      <div className="w-full md:w-1/2 flex items-center justify-center p-6">
        <div className="w-full max-w-lg bg-white/80 backdrop-blur-md shadow-2xl rounded-2xl p-6">

          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800">School Registration Form</h2>
          </div>

          <div className="space-y-4">

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="labelStyle">Contact Person Name</label>
                <input
                  name="name"
                  value={formData.name}
                  placeholder="Enter your name"
                  onChange={handleChange}
                  className="inputStyle"
                />
              </div>

              <div>
                <label className="labelStyle">Designation</label>
                <select
                  name="designation"
                  value={formData.designation}
                  onChange={handleChange}
                  className="inputStyle"
                  defaultValue="Principal"
                >
                  <option value="" disabled>Select designation</option>
                  <option value="Principal">Principal</option>
                  <option value="Vice Principal">Vice Principal</option>
                  <option value="Technical Staff">Technical Staff</option>
                  <option value="School Staff">School Staff</option>
                </select>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="labelStyle">School Name</label>
                <input
                  name="schoolName"
                  value={formData.schoolName}
                  placeholder="Enter your school name"
                  onChange={handleChange}
                  className="inputStyle"
                />
              </div>

              <div>
                <label className="labelStyle">School Website(url)</label>
                <input
                  name="website"
                  value={formData.website}
                  placeholder="Enter school website (url)"
                  onChange={handleChange}
                  className="inputStyle"
                />
              </div>
            </div>

            <div>
              <label className="labelStyle">Email (This email will be used for further communication)</label>
              <input
                type="email"
                name="email"
                placeholder="example@gmail.com"
                value={formData.email}
                onChange={handleChange}
                disabled={emailVerified}
                className={`inputStyle ${
                  emailVerified ? "border-green-500 bg-green-50" : ""
                }`}
              />

              {!emailVerified && (
                <button
                  onClick={handleSendOtp}
                  className="mt-2 text-sm text-blue-600 hover:underline"
                >
                  {loading ? "Sending..." : "Send OTP"}
                </button>
              )}

              {otpSent && !emailVerified && (
                <div className="flex gap-2 mt-2">
                  <input
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    className="inputStyle"
                  />
                  <button
                    onClick={handleVerifyOtp}
                    className="bg-green-600 hover:bg-green-700 text-white px-4 rounded-lg"
                  >
                    Verify
                  </button>
                </div>
              )}
            </div>

            

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="labelStyle">Pincode</label>
                <input
                  name="pincode"
                  value={formData.pincode}
                  placeholder="6-digit pincode"
                  onChange={handleChange}
                  className="inputStyle"
                  required
                />
              </div>
              <div>
                <label className="labelStyle">City</label>
                <input
                  name="city"
                  value={formData.city}
                  placeholder="Enter city"
                  onChange={handleChange}
                  className="inputStyle"
                  readOnly
                />
              </div>

              
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="labelStyle">State</label>
                <input
                  name="state"
                  value={formData.state}
                  placeholder="Enter state"
                  onChange={handleChange}
                  className="inputStyle"
                  readOnly
                />
              </div>

              <div>
                <label className="labelStyle">Phone</label>
                <input
                  name="phone"
                  value={formData.phone}
                  placeholder="10-digit mobile number"
                  onChange={handleChange}
                  className="inputStyle"
                />
              </div>
            </div>

          </div>

          <button
            onClick={handleSubmit}
            className="w-full mt-6 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-semibold transition"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddForm;